import { create } from "zustand";
import type { AuthUser } from "./auth";
import { getStoredAuth, clearStoredAuth as clearAuth } from "./auth";

interface AuthStoreState {
  user: AuthUser | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  setAuth: (user: AuthUser) => void;
  clearAuth: () => void;
  setLoading: (loading: boolean) => void;
  restore: () => void;
}

export const useAuthStore = create<AuthStoreState>((set) => ({
  user: null,
  isAuthenticated: false,
  isLoading: false,

  setAuth: (user) => set({ user, isAuthenticated: true }),

  clearAuth: () => {
    clearAuth();
    set({ user: null, isAuthenticated: false });
  },

  setLoading: (isLoading) => set({ isLoading }),

  restore: () => {
    const stored = getStoredAuth();
    if (stored?.user) {
      set({ user: stored.user, isAuthenticated: true });
    }
  },
}));

export function expireAuthSession() {
  useAuthStore.getState().clearAuth();
}
